import logo2gis from '@/assets/process/2gis.svg';
import logoAdidas from '@/assets/process/adidas.svg';
import logoAvito from '@/assets/process/Avito.svg';
import logoBeats from '@/assets/process/beats.svg';
import logoEcco from '@/assets/process/Ecco.svg';
import logoGazprom from '@/assets/process/Gazprom.svg';
import logoHaval from '@/assets/process/haval.svg';
import logoKaspersky from '@/assets/process/Kaspersky.svg';
import logoLays from '@/assets/process/lays.svg';
import logoLoL from '@/assets/process/League_of_legends.svg';
import logoLukoil from '@/assets/process/lukoil.svg';
import logoMegafon from '@/assets/process/megafon.svg';
import logoMts from '@/assets/process/mts.svg';
import logoOmoda from '@/assets/process/Omoda.svg';
import logoOzon from '@/assets/process/ozon.svg';
import logoPepsi from '@/assets/process/Pepsi.svg';
import logoPuma from '@/assets/process/puma.svg';
import logoSkittles from '@/assets/process/skittles.svg';
import logoSportmaster from '@/assets/process/sportmaster.svg';
import logoSpotify from '@/assets/process/spotify.svg';
import logoTbank from '@/assets/process/Tbank.svg';
import logoTiktok from '@/assets/process/tiktok.svg';
import logoVolkswagen from '@/assets/process/Volkswagen.svg';
import logoYandex from '@/assets/process/Yandex.svg';
import logoVk from '@/assets/process/vk.svg';
import logoDirol from '@/assets/process/Dirol.svg';

const items = [
  { id: '2gis', name: '2GIS', logo: logo2gis },
  { id: 'adidas', name: 'Adidas', logo: logoAdidas },
  { id: 'avito', name: 'Avito', logo: logoAvito },
  { id: 'beats', name: 'Beats', logo: logoBeats },
  { id: 'ecco', name: 'Ecco', logo: logoEcco },
  { id: 'gazprom', name: 'Gazprom', logo: logoGazprom },
  { id: 'haval', name: 'Haval', logo: logoHaval },
  { id: 'kaspersky', name: 'Kaspersky', logo: logoKaspersky },
  { id: 'lays', name: 'Lays', logo: logoLays },
  { id: 'lol', name: 'League of Legends', logo: logoLoL },
  { id: 'lukoil', name: 'Лукойл', logo: logoLukoil },
  { id: 'megafon', name: 'МегаФон', logo: logoMegafon },
  { id: 'mts', name: 'МТС', logo: logoMts },
  { id: 'omoda', name: 'Omoda', logo: logoOmoda },
  { id: 'ozon', name: 'Ozon', logo: logoOzon },
  { id: 'pepsi', name: 'Pepsi', logo: logoPepsi },
  { id: 'puma', name: 'Puma', logo: logoPuma },
  { id: 'skittles', name: 'Skittles', logo: logoSkittles },
  { id: 'sportmaster', name: 'Спортмастер', logo: logoSportmaster },
  { id: 'spotify', name: 'Spotify', logo: logoSpotify },
  { id: 'tbank', name: 'Т-Банк', logo: logoTbank },
  { id: 'tiktok', name: 'TikTok', logo: logoTiktok },
  { id: 'volkswagen', name: 'Volkswagen', logo: logoVolkswagen },
  { id: 'yandex', name: 'Яндекс', logo: logoYandex },
  { id: 'vk', name: 'VK', logo: logoVk },
  { id: 'dirol', name: 'Dirol', logo: logoDirol },
];

const ClientMarqueePlaceholder = () => {
  const doubled = [...items, ...items];

  return (
    <section className="py-16 md:py-24 border-y border-border/50 overflow-hidden">
      <div className="relative">
        <div className="flex animate-marquee whitespace-nowrap">
          {doubled.map((client, i) => (
            <div
              key={`${client.id}-${i}`}
              className="group mx-5 md:mx-8 flex-shrink-0 flex items-center justify-center h-24 w-60 opacity-50 hover:opacity-100 transition-all duration-300"
            >
              <img
                src={client.logo}
                alt={client.name}
                className="max-h-full max-w-full object-contain brightness-0 invert transition-all duration-300 group-hover:[filter:brightness(0)_saturate(100%)_invert(85%)_sepia(100%)_saturate(500%)_hue-rotate(30deg)_brightness(110%)]"
              />
            </div>
          ))}
        </div>
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-background to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-background to-transparent pointer-events-none" />
      </div>
    </section>
  );
};

export default ClientMarqueePlaceholder;
